module.exports = __webpack_public_path__ + "img/dep.4efc130b.png";